export * from './google-tag-manager-id'